import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const MODIFY_ROLE_SUCCESS = "ADMIN-USER:MODIFY_ROLE_SUCCESS";

export interface ModifyRoleSuccessAction extends Action {
  type: typeof MODIFY_ROLE_SUCCESS;
  organization: OrganizationKeyName;
}

export const modifyRoleSuccessAction = (
  organization: OrganizationKeyName
): ModifyRoleSuccessAction => ({
  type: MODIFY_ROLE_SUCCESS,
  organization,
});
